//Mui
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
// components
import { Containery } from "../../../components/global/Container/container";
import { useState } from 'react';
import { TextField } from '@mui/material';
// MUI Date TimePicker
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Stack from '@mui/material/Stack';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';



const DiscountEditor = () => {
    const [ discountFormData,  setDiscountFormData] = useState({
        discountOn: "Item",
        selectedItem: 1,
        discountType: "percent",
        percentValue: 20,
        customerBy: "2",
        customerGet: "1",
        expreationTime: "Unlimited",
        dateFrom: formatDate(new Date()),
        dateTo: formatDate(new Date()),
    });

    const handleChange = (event, key) => {
        const value = event.target.value;
        if(key){
            discountFormData[key] = value; 
            setDiscountFormData({...discountFormData});
        }
    };

    const handleDateChange = (newValue, key) => {
        if(key){
            discountFormData[key] = formatDate(newValue); 
            setDiscountFormData({...discountFormData});
        }
    };

    // Date Formater
    function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;

        return [year, month, day].join('-');
    }













    return (
        <Containery className="grid grid-cols-1 gap-3">
            <div className="d-flex justify-content-between align-items-center"> <p className="p2 titleP500"> Discount Editor </p> </div>

            <div className='w-full grid grid-cols-1 sm:grid-cols-2 gap-3 mt-2'>
                <SelectItem lable="Discount on" handleChange={handleChange} value={discountFormData.discountOn} keyy="discountOn" options={["Item", "Category"]} />
                <SelectItem lable={discountFormData.discountOn === "Item" ? "Select Item" : "Select Category"} handleChange={handleChange} value={discountFormData.selectedItem} keyy="selectedItem" options={["1", "2"]} />
            </div>

            <div className='w-full grid grid-cols-1 sm:grid-cols-2 gap-3'>
                <SelectItem lable={"Discount Type"} handleChange={handleChange} value={discountFormData.discountType} keyy="discountType" options={["percent", "multi"]} />

                <div className='w-full'>
                    {  discountFormData.discountType == "percent" 
                        ? 
                        <TextField className='w-full' inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }} label="Percent value in %" variant="filled" value={discountFormData.percentValue} onChange={(e)=> handleChange(e, "percentValue")}/>
                        : 
                        <div className='grid grid-cols-2 gap-3'>
                            <TextField className='w-full' inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }} label="customer buy" variant="filled" value={discountFormData.customerBy} onChange={(e)=> handleChange(e, "customerBy")}/>
                            <TextField className='w-full' inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }} label="customer get" variant="filled" value={discountFormData.customerGet} onChange={(e)=> handleChange(e, "customerGet")}/>
                        </div>
                    }
                </div>
            </div>

            <div className={discountFormData.expreationTime == "Unlimited" ? 'w-full' : 'w-full grid grid-cols-1 sm:grid-cols-2 gap-3'}>
                <SelectItem lable={"Expreation Time"} handleChange={handleChange} value={discountFormData.expreationTime} keyy="expreationTime" options={["Unlimited", "Limited"]} />

                { discountFormData.expreationTime == "Limited" &&
                    <div className='grid grid-cols-2 gap-3 w-full'>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <Stack spacing={3} >
                            <DatePicker
                                renderInput={(props) => <TextField {...props} />}
                                label=" "
                                value={discountFormData.dateFrom}
                                onChange={(newValue)=> handleDateChange(newValue, "dateFrom")}
                            />
                            </Stack>
                        </LocalizationProvider> 
                        
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <Stack spacing={3}>
                            <DatePicker
                                renderInput={(props) => <TextField {...props} />}
                                label=" "
                                value={discountFormData.dateTo}
                                onChange={(newValue)=> handleDateChange(newValue, "dateTo")}
                            />
                            </Stack>
                        </LocalizationProvider>
                    </div>
                }

            </div>


           <OverViewCard />

        </Containery>
    );
}

export default DiscountEditor;







function SelectItem(p) {
    return(
        <FormControl fullWidth className='w-full'>
            <InputLabel id="demo-simple-select-label"> { p.lable } </InputLabel>

            <Select labelId="demo-simple-select-label" value={p.value} label={ p.lable } onChange={(e)=> p.handleChange(e, p.keyy)} variant="filled" >
                { p.options.map( (option, index) => <MenuItem key={p.value+"/"+index} value={option}> {option} </MenuItem> ) }
            </Select>
        </FormControl>
    )
}

function OverViewCard() {

    return(
        <div className='w-full'>
            <div className='overview-row flex'>
                <div className='overview-head'></div>
                <div className='overview-body'></div>
            </div>
        </div>
    )
}



/*
 <div className='selected-discount-item'>
    <div className='w-full flex items-center mb-2'>
        <p className='p2 titleP700 !mr-2'>Selected Item: </p>
        <p className='p2'> Burger Menu mit Pommes </p>
    </div>

    <div className='w-full flex items-center'>
        <p className='p2 titleP700 !mr-2'>Price: </p>
        <p className='p2'> 5 $ </p>
    </div>
</div>

*/